import { render, staticRenderFns } from "./AvailableTypes.vue?vue&type=template&id=0aa63cbe&scoped=true"
import script from "./AvailableTypes.vue?vue&type=script&lang=js"
export * from "./AvailableTypes.vue?vue&type=script&lang=js"
import style0 from "./AvailableTypes.vue?vue&type=style&index=0&id=0aa63cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa63cbe",
  null
  
)

export default component.exports